
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/content-migrations/jst/MoodleZip';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"control-group chooseMigrationFile\"></div>\n<div class=\"control-group selectQuestionBank\"></div>\n<div class=\"control-group content\">\n  <label class=\"control-label\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.moodle_zip")
  },data:data},helper ? helper.call(depth0, "content_migrations.moodle_zip.content", "Content", options) : helperMissing.call(depth0, "t", "content_migrations.moodle_zip.content", "Content", options)))
    + "</strong></label>\n  <div class=\"controls selectContent\"></div>\n</div>\n<div class=\"control-group options\">\n  <label class=\"control-label\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.moodle_zip")
  },data:data},helper ? helper.call(depth0, "content_migrations.moodle_zip.options", "Options", options) : helperMissing.call(depth0, "t", "content_migrations.moodle_zip.options", "Options", options)))
    + "</strong></label>\n  <div class=\"dateShift\"></div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  